export const voiceMeetingSessionIdMock = '22';
export const voiceMeetingHearingParticipantIdMock = '88882222';
export const voiceMeetingSecondHearingParticipantIdMock = '888833333';
export const twoLineVOCParticipantIdMock = '888844444';
export const voiceMeetingNewHearingParticipantIdMock = '88885555';
